(function(window, $){
    if(!window.SwymCallbacks){window.SwymCallbacks = [];}

    window.SwymCallbacks.push(function(){
        _swat.fetchWrtEventTypeET(function(products){
            wishlistRender(products);
            setMinHeight();

            var bouncing;
            $(window).on('resize', function() {
              clearInterval(bouncing);
              bouncing = setTimeout(function() {
                setMinHeight();
               }, 200);
            });
        }, _swat.EventTypes.addToWishlist);
    });

  wishlistRender = function(products) {
  $(document).ready(function() {
    var template = $('[data-wishlist-template]');
    var empty_template = $('[data-wishlist-empty]');
    var $wishlistContainer = $('#wishlist-content');

    var startLoading = function($context) {
        if($context) {
            $context.addClass('loading');
        } else {
            $wishlistContainer.addClass('loading');
        }
    }

    var stopLoading = function($context) {
        if($context) {
            $context.removeClass('loading');
        } else {
            $wishlistContainer.removeClass('loading');
        }
    }

    if (!products || products.length < 1) {
      empty_template.show();
      return;
    }

    var currencies = {
        'JPY': '¥',
        'USD': '$',
        'GBP': '£'
    }

    products.forEach(function(p) {
      var row = template.clone();
      var domain = p.du.replace('https://villari.it', `https://${window.location.host}`);

      row.removeClass('hidden');
      row.find('[data-name]').html(p.dt);
      row.find('[data-url]').attr('href', domain);
      row.find('[data-image]').attr('src', p.iu);
      row.find('[data-price]').html(p.pr + currencies[window.Shopify.currency.active]|| _swat.currency);

     /*  if(!p.stk) {
        row.find('[data-add]').addClass('disabled');
      } */


      row.find('[data-remove]').on('click', function(e) {
        e.preventDefault();
        startLoading(row);

        _swat.removeFromWishList(p, function callback() {
          row.remove();
          window.loadWishlistBubble(0);
          stopLoading(row);
        });
      });

      $wishlistContainer.append(row);
    });
  });
 }
})(window, jQuery);

function setMinHeight() {
  var product_tile_list = $('.product-tile__wrapper'),
    fields_list = product_tile_list.find('.product__meta a[data-url] span'),
    minHeight = 1;

  product_tile_list.each(function() {
    var $elHeight = $(this).find('.product__meta a[data-url] span').outerHeight();

    if ($elHeight > minHeight) {
      minHeight = $elHeight;
    }
  });

  fields_list.css('min-height', `${minHeight}px`);
}
